function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.00078 13.5864C0.610778 13.9764 0.610778 14.6102 1.00078 15.0002C1.39171 15.3911 2.02452 15.3911 2.41546 15.0002L8.00026 9.41465L13.5858 15.0002C13.9767 15.3902 14.6095 15.3902 15.0005 15.0002C15.3905 14.6092 15.3905 13.9764 15.0005 13.5855L9.41494 7.99997L14.9997 2.41349C15.3907 2.02349 15.3907 1.38975 14.9997 0.999745C14.6097 0.608809 13.976 0.608809 13.586 0.999745L8.00047 6.58623L2.41495 0.999745C2.02402 0.609745 1.39121 0.609745 1.00121 0.999745C0.610274 1.39068 0.610274 2.02349 1.00121 2.41442L6.58673 7.99995L1.00078 13.5864Z",
  fill: "#9F9F9F"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1f9f4f47.svg";
export { ForwardRef as ReactComponent };